// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".quansumcls {\n  width: 40px;\n  height: 20px;\n  border-radius: 5px;\n  color: #fff;\n  margin: 0 auto;\n  font-size: 12px;\n  font-weight: 600;\n}\n.quansumOver {\n  background-color: red;\n}\n.quansumDown {\n  background-color: gray;\n}\n.quansumEqual {\n  background-color: blue;\n}", ""]);
// Exports
module.exports = exports;
